import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, doc, setDoc } from "firebase/firestore";

import { getAuth } from "firebase/auth";

// Your existing config
const firebaseConfig = {
  apiKey: "AIzaSyAT1AyHKwt_AUeGRj5uraZ8gx34glmFcUA",
  authDomain: "pixwala-website.firebaseapp.com",
  projectId: "pixwala-website",
  storageBucket: "pixwala-website.firebasestorage.app",
  messagingSenderId: "953623721708",
  appId: "1:953623721708:web:0d11249262bb30852a17c9",
  measurementId: "G-J597QT9H7M",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app); // ✅ Add this

// ✅ Export these for use in your project
// export { db, doc, setDoc };
export { db, doc, setDoc, auth };
